var _rect, _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1016,
    viewBox: "0 0 1440 1016",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623_1264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -16,
    y: -65,
    width: 1456,
    height: 1081
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -64.9999,
    width: 1456,
    height: 1081,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623_1264)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_623_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50.3028 365.036L204.058 365.036C204.058 365.036 712.779 961.645 -50.3028 1096.64L-50.3028 365.036Z",
    fill: "#EEF3FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_623_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1461.27 1041.13L-15.5288 1041.13C-15.5288 1041.13 1067.73 192.236 1311.07 553.352C1541.3 895.022 1461.27 1041.13 1461.27 1041.13Z",
    fill: "#5280FF",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_623_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.507 671.105L1172.88 1181.55C1172.88 1181.55 799.422 870.675 464.717 1161.2L660.507 671.105Z",
    fill: "#00FFFF",
    fillOpacity: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_623_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.09 477.353L-410.429 114.464C-410.429 114.464 32.2822 319.873 278.972 -45.7814L219.09 477.353Z",
    fill: "#00FFFF",
    fillOpacity: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_623_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26.1681 337.649L-26.1681 -67.4081C-26.1681 -67.4081 232.716 229.708 122.588 296.452C18.3908 359.601 -26.1681 337.649 -26.1681 337.649Z",
    fill: "#5280FF",
    fillOpacity: 0.08
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1089.67C-182.582 1044.19 -13.0812 804.264 291.487 804.264C672.197 804.264 884.982 1363.31 1459.08 901.489",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 588.175C-182.582 542.699 -13.0812 302.774 291.487 302.774C672.197 302.774 884.982 861.815 1459.08 399.998",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1073.49C-182.582 1028.01 -13.0812 788.087 291.487 788.087C672.197 788.087 884.982 1347.13 1459.08 885.312",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1057.31C-182.582 1011.84 -13.0812 771.91 291.487 771.91C672.197 771.91 884.982 1330.95 1459.08 869.135",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1041.13C-182.582 995.658 -13.0812 755.733 291.487 755.733C672.197 755.733 884.982 1314.77 1459.08 852.957",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1024.96C-182.582 979.481 -13.0812 739.555 291.487 739.555C672.197 739.555 884.982 1298.6 1459.08 836.78",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 1008.78C-182.582 963.304 -13.0812 723.378 291.487 723.378C672.197 723.378 884.982 1282.42 1459.08 820.603",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 992.603C-182.582 947.127 -13.0812 707.201 291.487 707.201C672.197 707.201 884.982 1266.24 1459.08 804.426",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 976.426C-182.582 930.95 -13.0812 691.024 291.487 691.024C672.197 691.024 884.982 1250.07 1459.08 788.249",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 960.249C-182.582 914.773 -13.0812 674.848 291.487 674.848C672.197 674.848 884.982 1233.89 1459.08 772.072",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 944.071C-182.582 898.595 -13.0812 658.67 291.487 658.67C672.197 658.67 884.982 1217.71 1459.08 755.895",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 927.894C-182.582 882.418 -13.0812 642.493 291.487 642.493C672.197 642.493 884.982 1201.53 1459.08 739.718",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 911.718C-182.582 866.241 -13.0812 626.316 291.487 626.316C672.197 626.316 884.982 1185.36 1459.08 723.541",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 895.54C-182.582 850.064 -13.0812 610.139 291.487 610.139C672.197 610.139 884.982 1169.18 1459.08 707.364",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 879.363C-182.582 833.887 -13.0812 593.962 291.487 593.962C672.197 593.962 884.982 1153 1459.08 691.186",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 863.186C-182.582 817.71 -13.0812 577.785 291.487 577.785C672.197 577.785 884.982 1136.83 1459.08 675.009",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 847.009C-182.582 801.533 -13.0812 561.608 291.487 561.608C672.197 561.608 884.982 1120.65 1459.08 658.832",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 830.832C-182.582 785.356 -13.0812 545.43 291.487 545.43C672.197 545.43 884.982 1104.47 1459.08 642.655",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 814.654C-182.582 769.178 -13.0812 529.253 291.487 529.253C672.197 529.253 884.982 1088.29 1459.08 626.478",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 798.477C-182.582 753.001 -13.0812 513.076 291.487 513.076C672.197 513.076 884.982 1072.12 1459.08 610.301",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 782.3C-182.582 736.824 -13.0812 496.899 291.487 496.899C672.197 496.899 884.982 1055.94 1459.08 594.124",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 766.123C-182.582 720.647 -13.0812 480.722 291.487 480.722C672.197 480.722 884.982 1039.76 1459.08 577.946",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 749.946C-182.582 704.47 -13.0812 464.544 291.487 464.544C672.197 464.544 884.982 1023.59 1459.08 561.769",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 733.769C-182.582 688.293 -13.0812 448.368 291.487 448.368C672.197 448.368 884.982 1007.41 1459.08 545.592",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 717.592C-182.582 672.116 -13.0812 432.19 291.487 432.19C672.197 432.19 884.982 991.232 1459.08 529.415",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 701.414C-182.582 655.938 -13.0812 416.013 291.487 416.013C672.197 416.013 884.982 975.054 1459.08 513.238",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 685.237C-182.582 639.761 -13.0812 399.836 291.487 399.836C672.197 399.836 884.982 958.877 1459.08 497.061",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 669.061C-182.582 623.585 -13.0812 383.66 291.487 383.66C672.197 383.66 884.982 942.701 1459.08 480.884",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 652.883C-182.582 607.407 -13.0812 367.482 291.487 367.482C672.197 367.482 884.982 926.524 1459.08 464.707",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 636.706C-182.582 591.23 -13.0812 351.305 291.487 351.305C672.197 351.305 884.982 910.346 1459.08 448.529",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 620.529C-182.582 575.053 -13.0812 335.127 291.487 335.127C672.197 335.127 884.982 894.169 1459.08 432.352",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.412 604.352C-182.582 558.876 -13.0812 318.951 291.487 318.951C672.197 318.951 884.982 877.992 1459.08 416.176",
    stroke: "white",
    strokeWidth: 0.987317
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 399.072C-96.0717 372.167 73.4291 230.218 377.997 230.218C758.707 230.218 971.492 560.968 1545.59 287.74",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 102.371C-96.0717 75.466 73.4291 -66.4829 377.997 -66.4829C758.707 -66.4829 971.492 264.267 1545.59 -8.96113",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 389.501C-96.0717 362.596 73.4291 220.647 377.997 220.647C758.707 220.647 971.492 551.397 1545.59 278.169",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 379.93C-96.0717 353.025 73.4291 211.076 377.997 211.076C758.707 211.076 971.492 541.826 1545.59 268.598",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 370.359C-96.0717 343.454 73.4291 201.505 377.997 201.505C758.707 201.505 971.492 532.255 1545.59 259.027",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 360.788C-96.0717 333.883 73.4291 191.934 377.997 191.934C758.707 191.934 971.492 522.684 1545.59 249.456",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 351.217C-96.0717 324.312 73.4291 182.363 377.997 182.363C758.707 182.363 971.492 513.113 1545.59 239.885",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 341.646C-96.0717 314.741 73.4291 172.792 377.997 172.792C758.707 172.792 971.492 503.542 1545.59 230.314",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 332.075C-96.0717 305.17 73.4291 163.221 377.997 163.221C758.707 163.221 971.492 493.971 1545.59 220.743",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 322.504C-96.0717 295.599 73.4291 153.65 377.997 153.65C758.707 153.65 971.492 484.4 1545.59 211.172",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 312.933C-96.0717 286.028 73.4291 144.079 377.997 144.079C758.707 144.079 971.492 474.829 1545.59 201.601",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 303.362C-96.0717 276.457 73.4291 134.508 377.997 134.508C758.707 134.508 971.492 465.258 1545.59 192.03",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 293.792C-96.0717 266.886 73.4291 124.937 377.997 124.937C758.707 124.937 971.492 455.687 1545.59 182.459",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 284.22C-96.0717 257.315 73.4291 115.366 377.997 115.366C758.707 115.366 971.492 446.116 1545.59 172.888",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 274.649C-96.0717 247.744 73.4291 105.795 377.997 105.795C758.707 105.795 971.492 436.545 1545.59 163.317",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 265.078C-96.0717 238.173 73.4291 96.2241 377.997 96.2241C758.707 96.2241 971.492 426.974 1545.59 153.746",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 255.507C-96.0717 228.602 73.4291 86.6532 377.997 86.6532C758.707 86.6532 971.492 417.403 1545.59 144.175",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 245.936C-96.0717 219.031 73.4291 77.082 377.997 77.082C758.707 77.082 971.492 407.832 1545.59 134.604",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 236.365C-96.0717 209.46 73.4291 67.511 377.997 67.511C758.707 67.511 971.492 398.261 1545.59 125.033",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 226.794C-96.0717 199.889 73.4291 57.9401 377.997 57.9401C758.707 57.9401 971.492 388.69 1545.59 115.462",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 217.223C-96.0717 190.318 73.4291 48.3691 377.997 48.3691C758.707 48.3691 971.492 379.119 1545.59 105.891",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 207.652C-96.0717 180.747 73.4291 38.7981 377.997 38.7981C758.707 38.7981 971.492 369.548 1545.59 96.3199",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 198.081C-96.0717 171.176 73.4291 29.2268 377.997 29.2268C758.707 29.2268 971.492 359.977 1545.59 86.7486",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 188.51C-96.0717 161.605 73.4291 19.6562 377.997 19.6562C758.707 19.6562 971.492 350.406 1545.59 77.178",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 178.939C-96.0717 152.034 73.4291 10.0851 377.997 10.0851C758.707 10.0851 971.492 340.835 1545.59 67.6069",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 169.368C-96.0717 142.463 73.4291 0.513916 377.997 0.513916C758.707 0.513916 971.492 331.264 1545.59 58.0357",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 159.797C-96.0717 132.892 73.4291 -9.05713 377.997 -9.05713C758.707 -9.05713 971.492 321.693 1545.59 48.4646",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 150.226C-96.0717 123.321 73.4291 -18.6278 377.997 -18.6278C758.707 -18.6278 971.492 312.122 1545.59 38.894",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 140.655C-96.0717 113.75 73.4291 -28.199 377.997 -28.199C758.707 -28.199 971.492 302.551 1545.59 29.3228",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 131.084C-96.0717 104.179 73.4291 -37.77 377.997 -37.77C758.707 -37.77 971.492 292.98 1545.59 19.7518",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 121.513C-96.0717 94.6077 73.4291 -47.3412 377.997 -47.3412C758.707 -47.3412 971.492 283.409 1545.59 10.1806",
    stroke: "white",
    strokeWidth: 0.987317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.901 111.942C-96.0717 85.0368 73.4291 -56.9121 377.997 -56.9121C758.707 -56.9121 971.492 273.838 1545.59 0.609666",
    stroke: "white",
    strokeWidth: 0.987317
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter5_f_623_1264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1208.5,
    cy: 193.5,
    r: 376.5,
    fill: "#DDF8F4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter6_f_623_1264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 618.5,
    cy: 952.5,
    r: 407.5,
    fill: "#D2EEF9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_623_1264",
    x: -218.147,
    y: 197.192,
    width: 756.162,
    height: 1067.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.9219,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_623_1264",
    x: -183.373,
    y: 296.058,
    width: 1825.95,
    height: 912.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.9219,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_623_1264",
    x: 296.873,
    y: 503.261,
    width: 1043.85,
    height: 846.131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.9219,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_623_1264",
    x: -578.273,
    y: -213.625,
    width: 1025.09,
    height: 858.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.9219,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_623_1264",
    x: -194.012,
    y: -235.252,
    width: 511.723,
    height: 744.437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.9219,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_623_1264",
    x: 532,
    y: -483,
    width: 1353,
    height: 1353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_623_1264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_623_1264",
    x: -89,
    y: 245,
    width: 1415,
    height: 1415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_623_1264"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.0c9f8d02a912bca8c2db1f2830abf815.svg";
export { ForwardRef as ReactComponent };